const MockWelcomeBoard = {
    title: "Welcome to Kavida!",
    description:
      `Follow a quick 3 minute tour to find out how you can use \nKavida to ensure your purchase orders arrive on time. 
       \nPlease turn off your popup blocker before you continue.`,
    buttonLabel: "Begin Tour"
  };

  const MockCommandTower = {
    title: "Welcome to your Control Tower. ",
    buttonLabel: "Continue",
    keyPoints: [
      "Track your purchase orders ",
      "Communicate with your suppliers ",
      "Detect and monitor risks to your orders ",
      "Track shipping logistics",
      "Manage documentation"
    ],
  };
  
  const MockGlobalRisks = {
    title: "Global Risk checks for events which could impact your orders.",
    buttonLabel: "Continue",
    keyPoints: [
      "Find your supplier’s location on a global map",
      "Understand the risks in the supply chain",
      "View port dwell times and estimated arrivals"
    ],
  };
  
  const MockMileStoneTrackerModal = {
    title: "The Order Manager is where you can manage and track your purchase orders.",
    buttonLabel: "Continue",
    keyPoints: [
      "Track your orders ",
      "Communicate with suppliers ",
      "Manage documents",
      "See risks to orders in more detail"
    ],
  };

  export const USER_NAME = 'Jones Ferdinand';
  export const JOB_TITLE = 'Procurement Manager';
  export const LOCATION = 'Colombo, Sri Lanka';
  
  export { MockCommandTower, MockWelcomeBoard, MockMileStoneTrackerModal, MockGlobalRisks };
  